import { Link, useLocation } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";

import "./styles.css";
import {
    faHome,
    faMailBulk,
    faPhone,
    faPrint,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IAtendimentoVendas } from "../../../Interfaces/Vendas/GestaoAtendimentos/AtendimentosVendas";
import { InforAtendimentoVendas } from "./Vendas/InforAtendimentoVendas";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export interface IAtendimentoV2 {
    ID_CASO: number;
    DS_CASO: string;
    DS_CONTA: string;
    NR_TELEFONE: Array<string>;
    DS_ETAPA: string;
    BodyVendas: IAtendimentoVendas;
}

interface IcardConfigV2 {
    ConfigAtendimento: IAtendimentoV2;
}

export function AtendimentoV2(props: IcardConfigV2) {
    const modulo = useLocation().pathname.split("/")[1];

    function handleBodyModuloCharger(Modulo: string) {
        switch (Modulo) {
            case ACESSOS.VENDAS.NAME:
                return (
                    <InforAtendimentoVendas
                        DS_ETAPA={props.ConfigAtendimento.DS_ETAPA}
                        InforCliente={
                            props.ConfigAtendimento.BodyVendas.InforCliente
                        }
                        InforEquipeAtendimento={
                            props.ConfigAtendimento.BodyVendas
                                .InforEquipeAtendimento
                        }
                        InforProdutosVendas={
                            props.ConfigAtendimento.BodyVendas
                                .InforProdutosVendas
                        }
                        InforVendas={
                            props.ConfigAtendimento.BodyVendas.InforVendas
                        }
                        InforAnaliseCredito={
                            props.ConfigAtendimento.BodyVendas
                                .InforAnaliseCredito
                        }
                        lstInforProposta={
                            props.ConfigAtendimento.BodyVendas.lstInforProposta
                        }
                        ID_CASO={props.ConfigAtendimento.ID_CASO}
                    />
                );
            default:
                break;
        }
    }
    //"top: -2px; right: 20px;"
    return (
        <div className="card card-custom gutter-b">
            <div className="card-header min-h-50 card-header-left ribbon ribbon-top ribbon-ver pl-4">
                <div
                    className="ribbon-target"
                    style={{
                        top: "-2px",
                        right: "150px",
                        backgroundColor: "var(--Vendas)",
                    }}
                >
                    {props.ConfigAtendimento.ID_CASO}
                </div>
                <div className="card-title">
                    <span className="card-icon ml-5">
                        <FontAwesomeIcon icon={faUser} className="mr-5" />
                    </span>
                    <h3 className="card-label">
                        <div className="d-flex justify-content-start">
                            <div className="d-flex flex-column">
                                {props.ConfigAtendimento.DS_CONTA}

                                <label className="font-size-sm text-dark mt-2">
                                    Corretor:{" "}
                                    <strong>
                                        {
                                            props.ConfigAtendimento.BodyVendas
                                                .InforEquipeAtendimento
                                                .DS_USUARIO_RESPONSAVEL
                                        }
                                    </strong>{" "}
                                    -{" "}
                                    {
                                        props.ConfigAtendimento.BodyVendas
                                            .InforEquipeAtendimento
                                            .DS_EQUIPE_VENDA_CORRETOR
                                    }
                                </label>
                            </div>
                        </div>
                    </h3>
                </div>

                <div
                    className="card-toolbar"
                    style={{
                        top: "-2px",
                        right: "60px",
                    }}
                >
                    <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-gray-500">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                version="1.1"
                            >
                                <g
                                    stroke="none"
                                    stroke-width="1"
                                    fill="none"
                                    fill-rule="evenodd"
                                >
                                    <rect
                                        x="0"
                                        y="0"
                                        width="24"
                                        height="24"
                                    ></rect>
                                    <path
                                        d="M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z"
                                        fill="#000000"
                                    ></path>
                                    <path
                                        d="M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z"
                                        fill="#000000"
                                        opacity="0.3"
                                    ></path>
                                </g>
                            </svg>
                        </span>
                        <a
                            href="/#"
                            className="font-weight-bolder text-primary ml-2"
                        >
                            Documentos
                        </a>
                    </div>
                </div>
            </div>
            <div className="card-body pt-3 pb-3">
                {handleBodyModuloCharger(modulo)}
            </div>
            <div className="card-footer d-flex align-items-center  justify-content-between pt-3 pb-3">
                <div className="d-flex">
                    <a
                        href="/#"
                        className="btn btn-sm btn-icon btn-light-primary mr-2 icon-xl"
                    >
                        <FontAwesomeIcon icon={faPhone} />
                    </a>
                    <a
                        href="/#"
                        className="btn btn-sm btn-icon btn-light-success mr-2 icon-xl"
                    >
                        <FontAwesomeIcon icon={faWhatsapp} />
                    </a>
                    <a
                        href="/#"
                        className="btn btn-sm btn-icon btn-light-warning mr-2 icon-xl"
                    >
                        <FontAwesomeIcon icon={faMailBulk} />
                    </a>
                    <a
                        href="/#"
                        className="btn btn-sm btn-icon btn-light-info mr-2 icon-xl"
                    >
                        <FontAwesomeIcon icon={faHome} />
                    </a>
                    <a
                        href="/#"
                        className="btn btn-sm btn-icon btn-light-danger mr-2 icon-xl"
                    >
                        <i className="icon-2x flaticon2-calendar-2"></i>
                    </a>
                    <a
                        href="/#"
                        className="btn btn-sm btn-icon btn-light-dark mr-2 icon-xl"
                    >
                        <FontAwesomeIcon icon={faPrint} />
                    </a>
                </div>

                <div className="d-flex flex-column align-itens-center justify-content-start text-align-end">
                    <label className="mt-2">
                        <strong>Ultima Interação</strong>: 30/10/2021 15:00:30 -
                        <strong className="text-danger">
                            Sem Interação 337 dias 16 horas 12 minutos
                        </strong>
                    </label>
                    <p className="m-0">
                        Willian Gomes Vitor - Teste testando teste testando
                        <a
                            href="/#"
                            className="font-weight-bolder text-primary ml-2"
                        >
                            {" "}
                            Ver Historico
                        </a>
                    </p>
                </div>
                <Link
                    to={ACESSOS.VENDAS.TELAS.ATENDIMENTO.DS_LINK(
                        props.ConfigAtendimento.ID_CASO || 0
                    )}
                    type="button"
                    className="btn btn-outline-primary btn-sm text-uppercase font-weight-bolder mt-5 mt-sm-0 mr-auto mr-sm-0"
                >
                    <i className="flaticon2-pen "></i> Atender
                </Link>
            </div>
        </div>
    );
}
